export default __webpack_public_path__ + "assets/images/08a7fe4c388fe6602ea62a8f15504589.svg";